export default "__VITE_ASSET__a808f96f__"